import { CollectionsApiClient } from '@fourthwall/services/dist/CollectionsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useAvailabilityMutation = createMutationHook(
  CollectionsApiClient.updateCollectionAvailability,
  {
    mutationKey: ['availability'],
  },
)
